import api from './interceptor';

const BASE_URL_V1 = 'api/v1/subscriptions';

export default {
  // API Version 2
  getFormUrlForUpgradeDependents: () => api.get(`${BASE_URL_V1}/upgrade-family-plan-form`),
  subscribePlan: params => api.post(`${BASE_URL_V1}`, params),
  unsubscribePlan: params => api.delete(`${BASE_URL_V1}`, { data: params }),
  changeCard: params => api.patch(`${BASE_URL_V1}`, params),
};
